import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { FormElementsModule } from '../form-elements/form-elements.module';
import * as CommonComponents from '../common-components';
import { Ng5SliderModule } from 'ng5-slider';
import { AddressSearchComponent } from './address-search/address-search.component';
import { CurrencyModule } from '../shared';
import { AddPensionSourceComponent } from './add-pension-source/add-pension-source.component';
import { ModalMeicalUnderwritingComponent } from './modal-meical-underwriting/modal-meical-underwriting.component';
import { OnlyNumberModule } from '../pages/medical-underwriting/directives/custom-onlyNumber-directive';
import { SafePipe } from '../pages/medical-underwriting/pipe/safe.pipe';
import { PensionProviderSearchComponent } from './pension-provider-search/pension-provider-search.component';
@NgModule({
  declarations: [
    CommonComponents.BreadcrumbComponent,
    CommonComponents.HeaderComponent,
    CommonComponents.ContentTopNavComponent,
    CommonComponents.ContentBottomNavComponent,
    CommonComponents.FooterComponent,
    CommonComponents.YellowTagComponent,
    CommonComponents.SaveComponent,
    CommonComponents.QuestionComponent,
    CommonComponents.PersonalDetailsComponent,
    CommonComponents.PensionSourceComponent,
    CommonComponents.AddPensionSourceComponent,
    CommonComponents.ModalComponent,
    CommonComponents.ProductTilesComponent,
    CommonComponents.SimpleSliderComponent,
    CommonComponents.NotificationComponent,
    CommonComponents.EditDetailsComponent,
    CommonComponents.ModalOptionComponent,
    CommonComponents.AddressSearchComponent,
    CommonComponents.CurrencyComponent,
    CommonComponents.GridTilesNewComponent,
    CommonComponents.RadioToggleButtonNewComponent,
    CommonComponents.SearchInputComponent,
    CommonComponents.InputComponent,
    CommonComponents.TextOnlyComponent,
    CommonComponents.CurrencyComponent,
    CommonComponents.PercentageCurrencyComponent,
    CommonComponents.DateDropdownComponent,
    CommonComponents.EmailComponent,
    CommonComponents.ConntactNoComponent,
    CommonComponents.AddressLinesComponent,
    CommonComponents.SessionTimeoutComponent,
    AddPensionSourceComponent,
    ModalMeicalUnderwritingComponent,
    CommonComponents.PensionProviderSearchComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    FormElementsModule,
    Ng5SliderModule,
    CurrencyModule,
    OnlyNumberModule
    
  ],
  exports: [
    CommonComponents.BreadcrumbComponent,
    CommonComponents.HeaderComponent,
    CommonComponents.ContentTopNavComponent,
    CommonComponents.ContentBottomNavComponent,
    CommonComponents.FooterComponent,
    CommonComponents.YellowTagComponent,
    CommonComponents.SaveComponent,
    CommonComponents.QuestionComponent,
    CommonComponents.PersonalDetailsComponent,
    CommonComponents.PensionSourceComponent,
    CommonComponents.AddPensionSourceComponent,
    CommonComponents.ModalComponent,
    CommonComponents.ProductTilesComponent,
    CommonComponents.SimpleSliderComponent,
    CommonComponents.NotificationComponent,
    CommonComponents.EditDetailsComponent,
    CommonComponents.ModalOptionComponent,
    CommonComponents.AddressSearchComponent,
    CommonComponents.CurrencyComponent,
    CommonComponents.PercentageCurrencyComponent,
    CommonComponents.GridTilesNewComponent,
    CommonComponents.RadioToggleButtonNewComponent,
    CommonComponents.SearchInputComponent,
    CommonComponents.InputComponent,
    CommonComponents.TextOnlyComponent,
    CommonComponents.DateDropdownComponent,
    CommonComponents.EmailComponent,
    CommonComponents.ConntactNoComponent,
    CommonComponents.AddressLinesComponent,
    CommonComponents.SessionTimeoutComponent,
    CommonComponents.PensionProviderSearchComponent

  ]
})
export class CommonComponentsModule { }
